var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.687 17.04c.45.483.41 1.225-.09 1.66a1.257 1.257 0 0 1-1.725-.09L5.13 10.34a.503.503 0 0 1 0-.674l7.74-8.276a1.256 1.256 0 0 1 1.724-.09c.5.435.542 1.177.09 1.66-.547.585-6.595 7.032-6.595 7.032l6.597 7.05z"
})));
export default SvgIconArrowLeft;